export default __webpack_public_path__ + "media/govCloudBanner.6431ce70.png";